import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import Image from '../../../BaseComponents/Image'
import { VoteOption } from '..'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import BodyFont from '../../../Theme/Fonts/Body'

type VoteCardHolderProps = {
    cardValues: VoteOption
    onPress?: () => void
    marginRight?: number
    marginLeft?: number
    isHighestValue?: boolean
    testID?: string
}
const VoteCardHolder: FunctionComponent<VoteCardHolderProps> = ({
    cardValues,
    onPress,
    marginRight,
    marginLeft,
    testID,
}): ReactElement => {
    const { label, imageUrl, alt, percent, active } = cardValues

    return (
        <Grid height={90} minWidth={0} marginRight={marginRight} marginLeft={marginLeft}>
            <Touchable expand testID={testID} activeOpacity={percent ? 1 : 0.7} onPress={onPress}>
                <Grid
                    center
                    paddingTop={percent ? 3 : 22}
                    border="1px"
                    borderColor="moon-2"
                    borderRadius={4}
                    position="relative"
                    zIndex="1"
                    overflow="hidden"
                    minWidth={0}
                >
                    {percent ? (
                        <Grid
                            position="absolute"
                            bottom={-1}
                            width="100%"
                            zIndex="-1"
                            noExpand
                            backgroundColor={active ? 'moon-3' : 'tahitian-4'}
                            height={`${percent}%`}
                        />
                    ) : null}

                    {imageUrl ? (
                        <Image
                            imageUrl={imageUrl}
                            alt={alt}
                            width={20}
                            aspectRatio="1:1"
                            size="S"
                        />
                    ) : (
                        <Grid noExpand width={20} height={20} center>
                            <BodyFont>X</BodyFont>
                        </Grid>
                    )}
                    <Grid marginTop={9} paddingX={2} width="100%">
                        <SmallBodyFont numberOfLines={1} textAlign="center">
                            {label}
                        </SmallBodyFont>
                    </Grid>
                    {percent ? (
                        <Grid>
                            <SmallBodyFont
                                color={active ? 'onyx' : 'keshi'}
                                bold={active}
                                textAlign="center"
                                numberOfLines={1}
                            >
                                {`${percent}%`}
                            </SmallBodyFont>
                        </Grid>
                    ) : null}
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default VoteCardHolder
